import React from "react";
import autoBind from "react-autobind";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Link} from "react-router-dom";
import feathers from "../../feathers";
import {validate, validateEmail} from "../../feathers/hooks";
import Field from "../../components/Field";
import Logo from "../../components/Logo";

// Although this is a hook, we will call it
// directly bc the app.authenticate method does
// not call underlying feathers.service('authentication') hooks
const validateCreds = validate({
  email: validateEmail,
  password: "Password is required."
});

class Login extends React.Component {
  constructor(props) {
    super(props);
    const {query} = this.props.location || {query: {}};
    this.state = {
      error: null,
      fetching: false,
      data: {
        email: query.email ? query.email : "",
        password: query.password ? query.password : ""
      }
    };
    autoBind(this);
  }

  async handleSubmit(event) {
    event.preventDefault();
    let {data: creds} = this.state;
    try {
      creds = validateCreds({data: creds}).data;
    } catch (err) {
      this.setState({error: err.message});
      return;
    }
    this.setState({fetching: true, error: false});
    try {
      await feathers._authenticate({strategy: "local", ...creds});
      this.props.onSuccess("/map");
    } catch (err) {
      this.setState({error: err.message, fetching: false});
    }
  }

  handleChange({name, value}) {
    this.setState({data: {...this.state.data, [name]: value}});
  }

  render() {
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-12">
              <Paper className="unauthed-box">
                <div className="logo-container">
                  <Logo width={200} />
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-xs-12">
                      <Field
                        disabled={this.state.fetching}
                        type="email"
                        label="Email"
                        name="email"
                        value={this.state.data.email}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <Field
                        disabled={this.state.fetching}
                        label="Password"
                        type="password"
                        style={{marginBottom: 16}}
                        name="password"
                        value={this.state.data.password}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="row middle-xs">
                    <div className="col-xs">
                      <Link to="/signup" className="small text-muted link">
                        Sign Up
                      </Link>
                      <span className="small text-muted">,&nbsp;</span>
                      <Link to="/forgot-password" className="small text-muted link">
                        Forgot Password
                      </Link>
                    </div>
                    <div className="col-xs">
                      <Button
                        variant="contained"
                        disabled={this.state.fetching}
                        color="primary"
                        type="submit"
                        style={{float: "right"}}
                        onClick={this.handleSubmit}>
                        {this.state.fetching ? "Logging in!" : "Login"}
                      </Button>
                    </div>
                  </div>
                </form>
              </Paper>
              {this.state.fetching && <LinearProgress mode="indeterminate" />}
              {this.state.error && <div className="unauthed-error">{this.state.error}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/index.jsx